import React from 'react';
import { IconButton, SxProps, Theme } from '@mui/material';
import { Palette, PaletteColor } from '@mui/material/styles/createPalette';

const variants = {
    xs: 24,
    sm: 32,
    md: 48,
    lg: 72
};

export interface IRoundButtonProps {
    noBackground?: boolean;
    variant?: keyof typeof variants;
    toggled?: boolean;
    palleteKey?: keyof Palette;
}

const styles = (props: IRoundButtonProps, theme: Theme): SxProps<Theme> => {
    const palette = theme.palette[props.palleteKey || 'secondary'] as PaletteColor;
    const bgColor = props.noBackground ? 'transparent' : props.toggled ? palette.light : palette.main;
    const size = variants[props.variant || 'md'];
    return {
        backgroundColor: bgColor,
        color: theme.palette.text.primary,
        width: size,
        height: size,
        '&:hover': {
            transition: '0.2s',
            backgroundColor: bgColor,
            opacity: '0.8',
            transform: 'scale(1.1)'
        },
        '&:disabled': {
            backgroundColor: theme.palette.secondary.main
        }
    };
};

export function RoundButton(props: Parameters<typeof IconButton>[0] & IRoundButtonProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { noBackground, variant, toggled, palleteKey, ...others } = props;
    return <IconButton sx={{...styles }} {...others} />;
}
